module.exports = __webpack_public_path__ + "img/img06.948af7be.svg";